import { useMemberMedicationsTableColumns } from 'hooks/useMemberMedicationsTableColumns'
import DetailsSection from '../common/DetailsSection'
import { observer } from 'mobx-react-lite'
import { useMemo, useState } from 'react'
import useTable from '@ui-components-3/ui/lib/components/Table/hooks/useTable'
import CommonTable from 'components/common/tables/CommonTable/CommonTable'
import MedicationDetailsModal from '../common/MedicationDetailsModal'
import { Medication } from 'types/PrivateData/MedicalHistory/Medication'

type MedicationsSectionProps = {
  // TODO: improve visit type
  visit: any
}

const MedicationsSection = ({ visit }: MedicationsSectionProps) => {
  const [selectedMedication, setSelectedMedication] = useState<Medication | null>(null)

  const { memberExtendedData } = visit

  const { columns: baseColumns, data } = useMemberMedicationsTableColumns(
    memberExtendedData?.privateData?.medicalHistory?.medications || [],
  )

  const columns = useMemo(
    () => [
      ...baseColumns.filter((c) => c.id !== 'lastUpdated'),
      {
        id: 'actions',
        header: 'Action',
        cell: (cell: any) => (
          <button
            className="text-link-primary text-left whitespace-nowrap"
            type="button"
            onClick={() => setSelectedMedication(cell?.row?.original || null)}
          >
            View Details
          </button>
        ),
      },
    ],
    [baseColumns],
  )

  const table = useTable({
    // using the model with paginationType 'server' without pagination controls and event handlers
    // makes table acting like static table without pagination at all, so we can use all the benefits from
    // useTable hook as well as reuse existing CommonTable component
    // Also, we can reuse columns for medications table from in other places (useMemberMedicationsTableColumns hook)
    paginationType: 'server',
    columns,
    data,
    rowId: 'name',
  })

  if (!data?.length) {
    return null
  }

  return (
    <DetailsSection title="Medication">
      <div className="max-h-[500px] overflow-y-auto">
        <CommonTable
          aria-label="Medications Table"
          model={table}
          className="w-full typography-body font-medium"
          hideFooter
          containerClassName="!min-h-max !basis-auto"
        />
      </div>
      {!!selectedMedication && (
        <MedicationDetailsModal medication={selectedMedication} onClose={() => setSelectedMedication(null)} />
      )}
    </DetailsSection>
  )
}

export default observer(MedicationsSection)
